import { Snackbar, Alert } from '@mui/material';
import { useState } from "react";

const SnackbarAlert = ({ alert }) => {
    return (
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            autoHideDuration={6000}
            open={alert.isOpen}
            onClose={alert.handleClose}>
            <Alert severity={alert.severity}>{alert.message}</Alert>
        </Snackbar>
    );
};

export const useAlert = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('');

    const show = (message, severity) => {
        setIsOpen(true);
        setMessage(message);
        setSeverity(severity);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return { isOpen, message, severity, show, handleClose };
};

export default SnackbarAlert;